import { getCmsTravelPassOffers } from "../../../app/api/getCmsTravelPassOffers";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { ICmsTravelPassOfferResponse } from "../../../Orchestrator/Types/Interface/ICMSOffers";

class GetCmsTravelPassOfferAction extends BaseAction<ICmsTravelPassOfferResponse | null, void> {
  override async run(): Promise<ICmsTravelPassOfferResponse | null> {
    let result: ICmsTravelPassOfferResponse | null = null

    try {
      const response = await getCmsTravelPassOffers();

      if (response.status === "ok" && response.answer) {
        result = response.answer;
      } else {
        console.warn("Failed to fetch monthly pass offer.");
      }
    } catch {
      console.error("Failed to fetch monthly pass offer");
    } finally {
      updateRecoilState("cmsTravelPassOfferResponseAtom", result);
      return result
    }
  }
}

export const getCmsTravelPassOfferAction = new GetCmsTravelPassOfferAction();
